import { onBeforeUnmount, onMounted, ref } from "vue";
import { H5_MODE_EVENT, isH5Mode } from "@/utils/h5-mode";

export const MOBILE_BREAKPOINT = 960;

/** Share the shell breakpoint without replacing page state when the viewport changes. */
export function useMobileLayout() {
  const isMobile = ref(typeof window !== "undefined" && (isH5Mode() || window.innerWidth <= MOBILE_BREAKPOINT));
  const update = () => { isMobile.value = isH5Mode() || window.innerWidth <= MOBILE_BREAKPOINT; };
  onMounted(() => {
    update();
    window.addEventListener("resize", update);
    window.addEventListener(H5_MODE_EVENT, update);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("resize", update);
    window.removeEventListener(H5_MODE_EVENT, update);
  });
  return { isMobile };
}
